import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "p-7" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import FormSection from './FormSection.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import PageLoader from '@/components/PageLoader.vue';

import AuthService from '@/classes/AuthService';
import AdminData from '@/classes/AdminData';
import { ref } from 'vue';

// DATA

export default /*@__PURE__*/_defineComponent({
  __name: 'CreatePage',
  setup(__props) {

const loader      = ref(false)
const show        = ref(false);
const showSuccess = ref(false);
const showError   = ref(false);
const errorMsg    = ref(false);

const form = ref({
    first_name : null,
    last_name : null,
    email     : null,
    role_id   : null,
    company_id   : null,
})
const errors = ref([]);


const submit = async () => {
  loader.value = true;

  try {
    await AdminData.storeAdmin(form.value);
    loader.value      = false;
    show.value        = false;
    showSuccess.value = true;

    setTimeout(() => {
      window.location.replace('/accounts/admins');
    }, 2000);

  } catch (error) {
    loader.value    = false;
    show.value      = false;
    showError.value = true;
    errorMsg.value  = error.response?.data?.message;

    if (error.response?.status === 422) {
      errors.value = error.response.data.errors;
    }
    errorResponse(error);
  }
};

const errorResponse = (err: object) => {
    loader.value = false
    if(err?.response.status == 401) AuthService.redirectToLogin()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "Create Admin",
    "show-back": "",
    backUrl: "/accounts/admins"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FormSection, {
          form: form.value,
          errors: errors.value
        }, {
          default: _withCtx(() => [
            (_ctx.$hasPermission('create-admin-account') || _ctx.$hasPermission('register-for-an-account'))
              ? (_openBlock(), _createBlock(ButtonComponent, {
                  key: 0,
                  onClick: submit,
                  disabled: loader.value
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode(" Save Changes ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["form", "errors"])
      ]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[0] || (_cache[0] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[1] || (_cache[1] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Close",
        title: "Admin",
        content: "Admin Created Successfully!"
      }, null, 8, ["show"]),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Warning",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[3] || (_cache[3] = ($event: any) => (showError.value = false)),
        errors: errors.value
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show", "errors"]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})